/** Build-time opt-ins for features that are optional on customer-owned deployments. */
export const SELF_SIGNUP_ENABLED = import.meta.env.VITE_SELF_SIGNUP_ENABLED === 'true';
export const DATA_SOURCES_ENABLED = import.meta.env.VITE_DATA_SOURCES_ENABLED === 'true';
export const GETTING_STARTED_ENABLED = import.meta.env.VITE_GETTING_STARTED_ENABLED === 'true';
export const BILLING_ENABLED = import.meta.env.VITE_BILLING_ENABLED === 'true';
export const SECURITY_ENABLED = import.meta.env.VITE_SECURITY_ENABLED === 'true';

/** Shared by sidebar, command palette and other links, including child routes. */
export function isDeploymentPathEnabled(href: string): boolean {
  const path = href.split(/[?#]/)[0];
  const at = (prefix: string) => path === prefix || path.startsWith(`${prefix}/`);
  if (at('/signup')) return SELF_SIGNUP_ENABLED;
  if (at('/settings/data-sources')) return DATA_SOURCES_ENABLED;
  if (at('/getting-started')) return GETTING_STARTED_ENABLED;
  if (at('/settings/security')) return SECURITY_ENABLED;
  if (at('/settings/billing') || at('/billing/return') || at('/platform/subscriptions')) return BILLING_ENABLED;
  return true;
}
